import { render, staticRenderFns } from "./SalesTaxFormModal.vue?vue&type=template&id=13773f7a"
import script from "./SalesTaxFormModal.vue?vue&type=script&lang=js"
export * from "./SalesTaxFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports